import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { linkStyles } from './cssstyles.js';

@customElement('report-viewer-header')
class ReportViewerHeader extends LitElement {

  override render() {

    return html`
      <app-header>
        <b><a href="/">Flakiness Report Viewer</a></b>
        <slot slot=center></slot>
      </app-header>
    `;
  }

  static styles = [linkStyles, css`

  `];
}
